import type { GetStaticProps, NextPage } from "next";
import { ManualPage } from "src/domains/shared/components/Home/Manual/ManualPage";
import { SiteLayout } from "src/domains/shared/components/Home/SiteShell/SiteLayout";
import { GcpAutoDetectGuideButton } from "src/domains/projects-list/components/ProjectDetailsDashboard/GcpAutoDetectGuide";

const Manual: NextPage = () => (
  <SiteLayout>
    {/* 매핑 절의 가이드는 GCP 행·요청 모달과 같은 컴포넌트다(service-manual 「자동 인식 안내와 가이드 진입」). */}
    <ManualPage
      mappingGuideEntry={<GcpAutoDetectGuideButton variant="text" />}
    />
  </SiteLayout>
);

export const getStaticProps: GetStaticProps = () => {
  return {
    props: {},
  };
};

export default Manual;
